// Localise a field that may be a plain string or a { fr, de, it, en } dict.
export const locField = (val, lang) => {
  if (val == null) return "";
  if (typeof val === "string") return val;
  return val[lang] || val.fr || val.en || Object.values(val).find(Boolean) || "";
};

export const REACTION_EMOJI = { like: "👍", fire: "🔥", heart: "❤️", sword: "⚔️" };
export const REACTION_ORDER = ["like", "fire", "heart", "sword"];
